var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXmlDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7144 11H1.71436V17H14.7144V11Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3752 20.1285H3.48202C2.90443 20.1285 2.34991 19.8977 1.94059 19.486C1.53118 19.0742 1.30066 18.515 1.30066 17.9314V4.07167C1.30066 3.48804 1.53118 2.9289 1.94059 2.5171C2.34991 2.10539 2.90443 1.87463 3.48202 1.87463H9.01662L14.7144 7.21661V18C14.7144 18.5086 14.3972 19.0026 13.9166 19.486C13.5073 19.8977 12.9528 20.1285 12.3752 20.1285Z",
    stroke: "#9B9B9B",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50699 12L4.10358 13.0582H4.13199L4.73568 12H5.83654L4.74989 13.8182L5.87915 15.6364H4.74989L4.13199 14.5568H4.10358L3.48568 15.6364H2.36353L3.47858 13.8182L2.39904 12H3.50699Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26223 12H7.49092L8.33609 14.0597H8.37871L9.22388 12H10.4526V15.6364H9.48666V13.5341H9.45825L8.64859 15.608H8.06621L7.25655 13.5199H7.22814V15.6364H6.26223V12Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9204 15.6364V12H11.9076V14.8409H13.3778V15.6364H10.9204Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlDisable);
export default __webpack_public_path__ + "static/media/XML_disable.a3497617fd821b53c20c2571e532deb1.svg";
export { ForwardRef as ReactComponent };